import { gql } from '@apollo/client';

export const DELETE_SURROUNDING_INFORMATION_MUTATION = gql`
  mutation DeleteSurroundingInformation($id: ID!) {
    deleteSurroundingInformation(input: { where: { id: $id } }) {
      surroundingInformation {
        id
      }
    }
  }
`;
